import React from "react";
import NewsletterThirteen from "../component/NewsletterThirteen";

function NewsletterThirteenContainer() {
  return <NewsletterThirteen />;
}

export default NewsletterThirteenContainer;
